import httpRequest from '@/utils/request'

// 分页查询
export function getList(data: any): Promise<any> {
    return httpRequest({
        url: '/ext/plansExt/page',
        method: 'post',
        data
    })
}

// 根据id查询
export function queryByID(id: any): Promise<any> {
    return httpRequest({
        url: `/ext/plansExt/h5/${id}`,
        method: 'get'
    })
}

// 查询统计列表数量
export function pageCount(data: any): Promise<any> {
    return httpRequest({
        url: 'ext/plansExt/pageCount',
        method: 'post',
        data
    })
}

// 查询工序(个人)
export function getWorkingProcedure(data: any): Promise<any> {
    return httpRequest({
        url: 'ext/proceduresExt/page',
        method: 'post',
        data
    })
}

// 根据ID发布计划
export function publishById(data: any): Promise<any> {
    return httpRequest({
        url: 'ext/plansExt/publishById',
        method: 'post',
        data
    })
}

// 根据ID分配计划
export function distributeById(data: any): Promise<any> {
    return httpRequest({
        url: 'ext/plansExt/distributeById',
        method: 'post',
        data
    })
}

// 查询当前用户全部范围内的全部工序
export function getSelfList(data: any): Promise<any> {
    return httpRequest({
        url: 'ext/proceduresExt/getSelfList',
        method: 'post',
        data
    })
}

// 终检分页查询
export function ZJPage(data: any): Promise<any> {
    return httpRequest({
        url: 'ext/endCheckExt/page',
        method: 'post',
        data
    })
}

// 终检根据ID查询
export function getById(id: any): Promise<any> {
    return httpRequest({
        url: `ext/endCheckExt/${id}`,
        method: 'get'
    })
}

// 查询设备
export function getDeviceByCondition(data: any): Promise<any> {
    return httpRequest({
        url: 'ext/deviceExt/getDeviceByCondition',
        method: 'post',
        data
    })
}

// 人员绑定设备信息
export function getFindAll(data: any): Promise<any> {
    return httpRequest({
        url: 'ext/userDeviceExt/findAll',
        method: 'post',
        data
    })
}

// 条件查询企业全部部门
export function deletejy(id: any): Promise<any> {
    return httpRequest({
        url: `ext/workorderCheckExt/delete/${id}`,
        method: 'get'
    })
}

// 根据对象信息查询
export function queryOne (data: any): Promise<any> {
    return httpRequest({
        url: '/ext/salaryParam/queryOne',
        method: 'post',
        data
    })
}

// 根据对象信息查询
export function queryList (data: any): Promise<any> {
    return httpRequest({
        url: '/ext/salaryParam/queryList',
        method: 'post',
        data
    })
}

// 一键报工
export function autoWorkReport (data: any): Promise<any> {
    return httpRequest({
        url: '/ext/plansExt/autoWorkReport',
        method: 'post',
        data
    })
}

// 根据id查询
export function getIdPlansExt(id: any): Promise<any> {
    return httpRequest({
        url: `/ext/plansExt/${id}`,
        method: 'get'
    })
}

// 列表查询
export function categoryExtList (data: any): Promise<any> {
    return httpRequest({
        url: '/ext/categoryExt/list',
        method: 'post',
        data
    })
}

// 查询全部
export function allUser (data: any): Promise<any> {
    return httpRequest({
        url: '/ext/companyUserExt/allUser',
        method: 'post',
        data
    })
}